import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

class TrackedClick extends Component {
    onClick(ev, childClick) {
        const { eventName, traits } = this.props;
        // segment click calls are mapped to GTM native click events
        if (window && window.analytics) {
            window.analytics.track(eventName, traits);
        }
        if (childClick) {
            childClick(ev);
        }
    }

    render() {
        const childrenWithProps = React.Children.map(this.props.children, child => {
            if (child) {
                const childClick = child.props.onClick;
                return React.cloneElement(child, { onClick: (ev) => this.onClick(ev, childClick) });
            }
            return <Fragment />;
        });
        return (
            <Fragment>
                {childrenWithProps}
            </Fragment>
        );
    }
}

TrackedClick.propTypes = {
    children: PropTypes.element.isRequired,
};

// segment track events are all mapped to GA4 'event' calls
export const trackEvent = (eventName, traits) => {
    if (window && window.analytics) {
        window.analytics.track(eventName, traits);
    }
};

export default TrackedClick;
